import { Module } from '../Module';
import { GetExtensionsServerSettingsRequest, IGetExtensionsServerSettingsResult } from '../ServerApi/requests/GetExtensionsServerSettingsRequest';
import { GetExtsvcServerSettingsRequest, IGetExtsvcServerSettingsResult } from '../ServerApi/requests/GetExtsvcServerSettingsRequest';
import { GetLastActiveDirectoryGroupsSyncTimeRequest, IGetLastActiveDirectoryGroupsSyncTimeResult } from '../ServerApi/requests/getLastActiveDirectoryGroupsSyncTimeRequest';
import { GetLastRecommendationTrainTimeRequest, IGetLastRecommendationTrainTimeResult } from '../ServerApi/requests/GetLastRecommendationTrainTimeRequest';
import { GetServerSettingsRequest, IGetServerSettingsResult } from '../ServerApi/requests/GetServerSettingsRequest';
import { SetRunNowForSitesRequest } from '../ServerApi/requests/SetRunNowForSitesRequest';
import { ISetSandboxForAllSitesParams, ISetSandboxForAllSitesResult, SetSandboxSettingsForAllSitesRequest } from '../ServerApi/requests/SetSandboxSettingsForAllSitesRequest';
import { IUpdateBooleanServerSettingResult, UpdateBooleanServerSettingRequest } from '../ServerApi/requests/UpdateBooleanServerSettingRequest';
import { IUpdateExtensionsServerSettingsParams, UpdateExtensionsServerSettingsRequest } from '../ServerApi/requests/UpdateExtensionsServerSettingsRequest';
import { IUpdateExtsvcServerSettingsParams, UpdateExtsvcServerSettingsRequest } from '../ServerApi/requests/UpdateExtsvcServerSettingsRequest';
import { IUpdateScheduleFrequencyServerSettingResult, UpdateScheduleFrequencyServerSettingRequest } from '../../backgroundJob/types/UpdateScheduleFrequencyServerSettingRequest';
import { IUpdateStringServerSettingResult, UpdateStringServerSettingRequest } from '../ServerApi/requests/UpdateStringServerSettingRequest';
import {
  IEditableServerSettings,
  IExtensionsServerSettings,
  IExtsvcServerSettings
} from '../ServerApi/types/IEditableServerSettings';
import { IResult, ITagResult } from '../ServerApi/types/IResponse';
import { IScheduleFrequency } from '../../schedule/types/ISchedule';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { ServerService } from '../services/ServerService';


export interface IServerTimestamps {
  lastRecommendationTrainTime: string;
  lastActiveDirectoryGroupsSyncTime: string;
}

export class ServerSettings {

  public static $inject = ['ServerService', 'ErrorNotifyingServer'];

  constructor(private server: ServerService, private errorNotifyingServer: ErrorNotifyingServer) {}

  public fetch(): ng.IPromise<IEditableServerSettings> {
    return this.server.sendRequest(new GetServerSettingsRequest({}))
      .then((result: IGetServerSettingsResult) => result.serverSettings);
  }

  public getExtensionsSettings(): ng.IPromise<IExtensionsServerSettings> {
    return this.server.sendRequest(new GetExtensionsServerSettingsRequest({}))
      .then((result: IGetExtensionsServerSettingsResult) => result);
  }

  public getExtsvcSettings(): ng.IPromise<IExtsvcServerSettings> {
    return this.server.sendTagRequest(new GetExtsvcServerSettingsRequest())
      .then((result: IGetExtsvcServerSettingsResult) => result);

  }

  public getTimestamps(): ng.IPromise<IServerTimestamps> {
    const timestamps: IServerTimestamps =
      {
        lastRecommendationTrainTime: null,
        lastActiveDirectoryGroupsSyncTime: null
      };
    return this.server.sendRequest(new GetLastRecommendationTrainTimeRequest())
      .then(
        (result: IGetLastRecommendationTrainTimeResult) => {
          timestamps.lastRecommendationTrainTime = result.time;
          return this.server.sendRequest(new GetLastActiveDirectoryGroupsSyncTimeRequest())
            .then((result: IGetLastActiveDirectoryGroupsSyncTimeResult) => {
              timestamps.lastActiveDirectoryGroupsSyncTime = result.time;
              return timestamps;
            });
          });
  }

  public updateBoolean(setting: string, value: boolean): ng.IPromise<IUpdateBooleanServerSettingResult> {
    const request = new UpdateBooleanServerSettingRequest({
      setting: setting,
      value: value
    });
    return this.server.sendRequest(request);
  }

  public updateString(setting: string, value: string): ng.IPromise<IUpdateStringServerSettingResult> {
    const request = new UpdateStringServerSettingRequest({
      setting: setting,
      value: value
    });
    return this.server.sendRequest(request);
  }

  public updateScheduleFrequency(setting: string, value: IScheduleFrequency): ng.IPromise<IUpdateScheduleFrequencyServerSettingResult> {
    const request = new UpdateScheduleFrequencyServerSettingRequest({
      setting: setting,
      value: value
    });
    return this.server.sendRequest(request);
  }

  public updateExtensionsSettings(extensionsSettings: IExtensionsServerSettings): ng.IPromise<IResult> {
    const params: IUpdateExtensionsServerSettingsParams = {
      settings: extensionsSettings
    };
    return this.errorNotifyingServer.sendRequest(new UpdateExtensionsServerSettingsRequest(params));
  }

  public updateExtsvSettings(extsvcSettings: IExtsvcServerSettings): ng.IPromise<IResult> {
    return this.errorNotifyingServer.sendTagRequest(new UpdateExtsvcServerSettingsRequest(extsvcSettings));
  }

  public updateRunNowSettings(sites: string[], shouldEnable: boolean): ng.IPromise<IResult> {
    return this.errorNotifyingServer.sendRequest(new SetRunNowForSitesRequest({sites, shouldEnable}));
  }

  public setSandboxSettingForExistingSites(shouldEnable: boolean): ng.IPromise<ISetSandboxForAllSitesResult> {
    const params: ISetSandboxForAllSitesParams = {
      shouldEnable: shouldEnable
    };
    return this.server.sendRequest(new SetSandboxSettingsForAllSitesRequest(params));
  }

}

Module.instance().service('ServerSettings', ServerSettings);
